<template>
  <div class="pb-12">
    <topbar>
      <div class="flex items-center justify-between px-1 lg:px-3">
        <div class="text-lg font-bold">
          Insights
        </div>
        <div>
          <router-link :to="{ name: 'MonitorMap' }" class="mr-2 btn btn-sm btn-secondary">
            Monitor <fa :icon="['far', 'desktop']" class="ml-2" />
          </router-link>
        </div>
      </div>
    </topbar>

    <div class="divide-y">
      <div class="max-w-6xl p-6 mx-auto mb-4 sm:p-8" v-if="account.subscription.automations">
        <overview-automations />
      </div>
      <div class="max-w-6xl p-6 mx-auto mb-4 sm:p-8" v-if="account.subscription.orders">
        <overview-orders />
      </div>
      <div class="max-w-6xl p-6 mx-auto mb-4 sm:p-8" v-if="account.subscription.records">
        <overview-records />
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OverviewAutomations from './OverviewAutomations'
import OverviewOrders from './OverviewOrders'
import OverviewRecords from './OverviewRecords'

export default {
  name: 'Overview',

  components: {
    OverviewAutomations,
    OverviewOrders,
    OverviewRecords
  },

  computed: {
    ...mapGetters(['account'])
  }
}
</script>